export default __webpack_public_path__ + "static/media/Ballroll_00049.4f24b510.png";